import { createMuiTheme } from '@material-ui/core/styles'

export default createMuiTheme({
  palette: {
    primary: {
      main: '#EBBD3F',
    },
  },
  overrides: {
    MuiPickersDay: {
      daySelected: {
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: 10,
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        minWidth: 240,
      },
      container: {
        alignItems: 'center',
      },
    },
    MuiPickersStaticWrapper: {
      staticWrapperRoot: {
        minWidth: 240,
      },
    },
  },
})



// WEBPACK FOOTER //
// ./src/theme/materialTheme.js